export const header = [
  'Этаж',
  'Наименование помещения',
  '№',
  'Площадь помещения',
  'Арендатор',
  'Собственник',
  'Статус аренды',
];
